import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-word': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9c9 9 14.1 21.3 14.1 34v332.1c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48.1h204.1c12.7 0 24.9 5.1 33.9 14.1zM332.1 128l-76.1-76.1v76.1h76.1zM48 464h288v-288h-104c-13.3 0-24-10.7-24-24v-104h-160v416zM268.1 256v-0.2h15.8c7.8 0 13.5 7.3 11.6 14.9-4.3 17-13.7 54.1-34.5 136-1.3 5.4-6.1 9.1-11.6 9.1h-24.7c-5.5 0-10.3-3.8-11.6-9.1-5.3-20.9-17.8-71-17.9-71.4l-2.9-17.3c-0.5 5.3-1.5 11.1-3 17.3l-17.9 71.4c-1.3 5.4-6.1 9.1-11.6 9.1h-25.2c-5.6 0-10.4-3.7-11.7-9.1-6.5-26.5-25.2-103.4-33.2-136-1.8-7.5 3.9-14.8 11.7-14.8h16.8c5.8 0 10.7 4.1 11.8 9.7 5 25.7 18.4 93.8 19.1 99 0.3 1.7 0.4 3.1 0.5 4.2 0.8-7.5 0.4-4.7 24.8-103.7 1.4-5.3 6.2-9.1 11.7-9.1h13.3c5.6 0 10.4 3.8 11.7 9.2 23.9 99.7 22.8 94.4 23.6 99.5 0.3 1.7 0.5 3.1 0.7 4.3 0.6-8.1 0.4-5.8 21-103.5 1.1-5.5 6-9.5 11.7-9.5z'
      }
    ]
  }
})
